<template>

	<div class="w-full">

        <div class="flex flex-wrap -mx-3">
			<Card class="w-full mb-6 px-3">
				<template v-slot:header>
					Recent Videos
					<router-link class="absolute top-0 right-0 px-2 py-1 mt-3 mr-3 text-gray-500 opacity-0 group-hover:opacity-100 transition-default transition-all" to="/stringer/videos">
						<i class="fas fa-arrow-circle-right"></i>
					</router-link>
				</template>
				<template v-slot:body>

					<CustomTable v-if="videos.length == 0">
						<template v-slot:body>
							<tr class="text-center">
								<td colspan="4" class="py-5">You have not uploaded any videos yet. Once you upload a video, it will appear here.</td>
							</tr>
						</template>
					</CustomTable>

					<CustomTable v-if="videos.length !== 0">
						<template v-slot:body>
							<tr v-for="video in videos">
								<td class="py-4 px-6 border-b border-grey-light w-48">
									<progressive-img fallback="/static/image-unavailable.png" :src="video.thumbnailUrl" />
								</td>
								<td class="py-4 px-6 border-b border-grey-light">
									<strong>{{ video.title }}</strong> <br/>
									{{ video.created_at | displayLocalDateTime }}<br/>
									
								</td>
								<td class="py-4 px-6 border-b border-grey-light text-right">
									<!-- <button class="bg-blue-700 px-2 py-1 rounded text-white mr-4" v-on:click="viewApprovalModal(video)" data-toggle="modal" data-target="#approveVideoModal">View</button>
									<button class="bg-red-700 px-2 py-1 rounded text-white" v-on:click="removeUpload(video.id)">Delete Video</button> -->
								</td>
							</tr>
							<tr class="bg-grey-lighter text-center" v-if="pollingVideos">
								<td class="py-5" colspan="4">
									<h1 class="text-xl"><i class="fa fa-circle-notch fa-spin"></i></h1>
								</td>
							</tr>
						</template>
					</CustomTable>
				</template>
			</Card>

			<div class="w-full flex">
				<Card class="w-full mb-6 lg:w-1/2 lg:mb-0 px-3 flex-grow">
					<template v-slot:header>
						Sales
						<router-link class="absolute top-0 right-0 px-2 py-1 mt-3 mr-3 text-gray-500 opacity-0 group-hover:opacity-100 transition-default transition-all" to="/stringer/sales">
							<i class="fas fa-arrow-circle-right"></i>
						</router-link>
					</template>
					<template v-slot:body>
						<canvas id="salesChart" class="p-3"></canvas>
					</template>
				</Card>

				<Card class="w-full lg:w-1/2 px-3 flex-grow" :wantsFullHeight="true">
					<template v-slot:header>
						Support Requests
						<router-link class="absolute top-0 right-0 px-2 py-1 mt-3 mr-3 text-gray-500 opacity-0 group-hover:opacity-100 transition-default transition-all" to="/stringer/support/tickets">
							<i class="fas fa-arrow-circle-right"></i>
						</router-link>
					</template>
					<template v-slot:body>
						<CustomTable>
							<template v-slot:header>
								<th class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Ticket ID</th>
								<th class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Title</th>
								<th class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Last Update</th>
								<th class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Status</th>
							</template>
							<template v-slot:body>
								<tr class="hover:bg-grey-lighter" v-for="ticket in tickets" v-if="!pollingTickets">
									<td class="py-4 px-6 border-b border-grey-light"><router-link :to="'/stringer/support/tickets/' + ticket.ticket_id" class="text-blue-600">{{ ticket.ticket_id }}</router-link></td>
									<td class="py-4 px-6 border-b border-grey-light">{{ ticket.title }}</td>
									<td class="py-4 px-6 border-b border-grey-light">{{ ticket.updated_at | displayLocalDateTime}}</td>
									<td class="py-4 px-6 border-b border-grey-light">{{ ticket.status }}</td>
								</tr>
								<tr class="hover:bg-grey-lighter" v-if="tickets.length == 0">
									<td class="py-4 px-6 border-b border-grey-light text-center" colspan="4">
										You haven't ever created a ticket. <router-link to="/stringer/support/tickets/new" class="text-blue-600">Open one</router-link> if you need support!
									</td>
								</tr>
								<tr class="bg-grey-lighter text-center" v-if="pollingTickets">
									<td class="py-5" colspan="4">
										<h1 class="text-xl"><i class="fa fa-circle-notch fa-spin"></i></h1>
									</td>
								</tr>
							</template>
						</CustomTable>
					</template>
				</Card>
			</div>
        </div>

    </div>

</template>

<script>

	import * as Config from '@/config'
	import { mapState, mapGetters } from 'vuex';
	import { EventBus } from '@/utils/events';
    import moment from 'moment';
	import Chart from 'chart.js';
	import _ from 'lodash'
	import download from 'downloadjs'

	import CustomTable from '@/components/general/CustomTable'
	import Card from '@/components/partials/Card'


	export default {
		name: 'HelloWorld',
		data () {
			return {
				msg: 'Welcome to Your Vue.js App',
				graphData: null,
				chart: null,
				canvas: null,
				content: null,
				timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
				view: {
					param: 'month',
					title: 'Month',
				},
				loadingReport: false,

				users: {},
				interval: null,
				version: 'loading...',
				pollingVideos: true,
				pollingTickets: true,
				videos: {},
				tickets: {},
			}
		},
		components: {
			CustomTable,
			Card,
		},
		mounted() {
			this.canvas = document.getElementById('salesChart')
			this.context = this.canvas.getContext('2d')
		
			this.getSalesGraphData();
			this.getRecentVideos();
			this.getRecentTickets();
			
			this.$nextTick(function () {
                EventBus.$on('admin-approve-video-refresh-data', this.getUpcomingVideos);
            }.bind(this));
		},

		methods: {
			...mapGetters([
                'getAuthorizationHeader',
			]),
			
			getSalesGraphData() {
				return this.$http.get(Config.apiPath + "/api/v2/stringer/graphs/sales", {
					headers: this.getAuthorizationHeader()['headers'],
					params: {
						filter: this.view.param,
						timezone: this.timezone,
					}
				}).then((response) => {
					this.graphData = response.data
					this.createSalesGraph();
                });
			},

			changeView (param, title) {
				// Don't reload the same view.
				if (this.view.param === param) return
				this.view = {
					param: param,
					title: title
				}
				this.getSalesGraphData().then(this.updateChart)
			},

			createSalesGraph() {

				if (this.chart !== null) {
					this.chart.destroy()
				}

				var data_keys = _.keys(this.graphData);
				if (0 < data_keys.length && data_keys[0].length > 10) {
					for (var i = 0; i < data_keys.length; i++) {
						data_keys[i] = data_keys[i].substr(11);
					}
				}

				this.chart = new Chart(this.context, {
					type: 'line',
					data: {
						labels: data_keys,
						datasets: [{
							data: _.values(this.graphData),
							backgroundColor: 'rgba(0,85,161,0.4)',
							borderColor: 'rgba(0,85,161,0.6)',
							// borderColor: "{{ color_darken($theme_metrics, -0.1) }}",
							// pointBackgroundColor: "{{ color_darken($theme_metrics, -0.1) }}",
							// pointBorderColor: "{{ color_darken($theme_metrics, -0.1) }}",
							// pointHoverBackgroundColor: "{{ color_darken($theme_metrics, -0.2) }}",
							// pointHoverBorderColor: "{{ color_darken($theme_metrics, -0.2) }}"
						}]
					},
					options: {
						tooltips: {
							callbacks: {
								label: function(tooltipItem, data) {
									if(tooltipItem.yLabel == 1) {
										return tooltipItem.yLabel + " sale";
									}
									return tooltipItem.yLabel + " sales";	
								}
							}
						},
						legend: {
							display: false
						},
				}})
			
			},

			getRecentVideos() {
                this.$http.get(Config.apiPath + "/api/v2/stringer/videos/recent", this.getAuthorizationHeader()).then((response) => {
					this.$set(this, 'videos', response.data)
                    this.$set(this, 'pollingVideos', false)
                });
			},

			getRecentTickets() {
				this.$http.get(Config.apiPath + "/api/v2/support/tickets/recent", this.getAuthorizationHeader()).then((response) => {
					this.$set(this, 'tickets', response.data)
                    this.$set(this, 'pollingTickets', false)
                });
			},
		},

		filters: {
			timeAgo: function(date) {
                return moment.utc(date).fromNow();
			},
			displayLocalDateTime: function(date) {
                return moment.utc(date).local().format('MMMM Do YYYY, h:mm a');
            },
		}
	}

</script>